import { render, staticRenderFns } from "./SelectionStat.vue?vue&type=template&id=12bc3a88&scoped=true&"
import script from "./SelectionStat.vue?vue&type=script&lang=js&"
export * from "./SelectionStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bc3a88",
  null
  
)

export default component.exports